import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

// import { format } from "date-fns";

import { H } from "@lifepay/rc-ui-toolkit";

// import Labeled from "components/visual/Labeled";
// import Badge from "components/visual/Badge";
// import CardSmsControl from "../controls/CardSmsControl";

import Limit from "../Limit";

// import cardtype from "./cardtype";
import styles from "./LimitGroup.m.scss";

function LimitGroup(props) {
  const { theme, limits, groupName } = props;
  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.header)}>
        <H t="h5">{groupName}</H>
      </div>
      <div className={classnames(theme.content)}>
        {limits.map((limit) => {
          return <Limit key={"limit" + limit.limitId} limit={limit} />;
        })}
      </div>
    </div>
  );
}

LimitGroup.displayName = "LimitGroup";

LimitGroup.propTypes = {
  theme: PropTypes.object,
  groupId: PropTypes.number,
  groupName: PropTypes.string,
  limits: PropTypes.array,
};

LimitGroup.defaultProps = {};

export default themr("@lifepay/LimitGroup", styles)(LimitGroup);



// WEBPACK FOOTER //
// ./src/components/emission/cards/limits/LimitGroup/LimitGroup.js